import React, { useEffect } from 'react';
import { localsMessages } from '../utility/getTemplateData';
import { Row, Col } from '@paypalcorp/pp-react';
import ConfirmationCheckmark from './ConfirmationCheckmark';
import ConfirmationMessage from './ConfirmationMessage';
import ConfirmationView from './ConfirmationView';
import withConfirmationData from './withConfirmationData';
import withConfirmationMessages from './withConfirmationMessages';
import withTheme from '../components/withTheme';
import PropTypes from 'prop-types';
import * as AppActions from '../actions/AppActions';
import { addClass } from '../utility/domUtils';
import { isInContext } from '../utility/inContextDonation';

const messages = localsMessages('confirmation/confirmation');

function SuccessView(props) {
  const {
    confirmationNumber,
    extraDonateAmount,
    giftAidConfText,
    giftaidFlag,
    rp_status,
    yourDonation,
    yourRPdonation,
  } = props;

  useEffect(() => {
    AppActions.showLanguageSelector(false);
  }, []);

  useEffect(() => {
    if (isInContext) {
      addClass('#mainWrapper', ['in-context-success-page']);
    }
  }, []);

  const SuccessMessage = () => (
    <Row>
      <Col xs={12}>
        <ConfirmationMessage
          yourDonation={rp_status ? yourRPdonation : yourDonation}
          giftaidFlag={giftaidFlag}
          extraDonateAmount={extraDonateAmount}
          giftAid={giftAidConfText}
        />
      </Col>
    </Row>
  );

  return (
    <ConfirmationView
      {...props}
      accountMessage={messages.label.AccountMessage}
      accountLink={messages.label.AccountLink}
      engamentText={messages.label.EngamentText}
      illustration={
        <ConfirmationCheckmark confirmationNumber={confirmationNumber} />
      }
      message={<SuccessMessage />}
    />
  );
}

SuccessView.propTypes = {
  confirmationNumber: PropTypes.string,
  extraDonateAmount: PropTypes.string,
  giftAidConfText: PropTypes.string,
  giftaidFlag: PropTypes.string,
  rp_status: PropTypes.bool,
  returnTo: PropTypes.string,
  returnText: PropTypes.string,
  yourRPdonation: PropTypes.object,
  yourDonation: PropTypes.object,
};

export default withConfirmationData(
  withConfirmationMessages(withTheme(SuccessView), messages, 'success')
);
